'use client';
import { GoBack } from '@/components/go-back';
import OptimizedLogo from '@/components/optimized-logo';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export default function Contact() {
  return (
    <section className="bg-ihs-accent-blue w-screen h-screen flex flex-col items-center justify-center">
      <Card className="w-[427px] rounded-2xl relative">
        <GoBack className="absolute top-5 left-4" />

        <CardHeader>
          <CardTitle className="flex items-center justify-center flex-col gap-6">
            <OptimizedLogo color="black" width={200} height={32} />

            <div className="space-y-2 text-center flex flex-col items-center">
              <h2 className="font-bold text-2xl">Need Help? Contact Us</h2>
              <p className="text-sm max-w-[250px] text-[#24292E] font-normal">
                For any queries or assistance, you can reach out to the
                appropriate team:
              </p>
            </div>
          </CardTitle>
        </CardHeader>

        <CardContent className="space-y-4">
          <div className="text-base text-gray-800 mb-4">
            For any queries or assistance, you can reach out to the appropriate
            team:
          </div>
          <div className="flex flex-col gap-3 text-base">
            <div>
              <span className="font-semibold">General Inquiries: </span>
              <a
                href="mailto:support@innovationhubsolutions.com"
                className="text-ihs-blue hover:underline"
              >
                support@innovationhubsolutions.com
              </a>
            </div>
            <div>
              <span className="font-semibold">
                Safety or Moderation Concerns:{' '}
              </span>
              <a
                href="mailto:moderation@innovationhubsolutions.com"
                className="text-ihs-blue hover:underline"
              >
                moderation@innovationhubsolutions.com
              </a>
            </div>
            <div>
              <span className="font-semibold">Partnership Opportunities: </span>
              <a
                href="mailto:hello@innovationhubsolutions.com"
                className="text-ihs-blue hover:underline"
              >
                hello@innovationhubsolutions.com
              </a>
            </div>
            <div>
              <span className="font-semibold">Follow us on LinkedIn: </span>
              <a
                href="https://www.linkedin.com/company/innovation-hub-solutions/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-ihs-blue hover:underline"
              >
                Innovation Hub Solutions
              </a>
            </div>
          </div>
          <div className="text-sm text-gray-600 mt-4">
            We'll get back to you as soon as possible. Thank you for being part
            of our community!
          </div>
        </CardContent>
      </Card>
    </section>
  );
}
